import { render } from "./report.vue?vue&type=template&id=5868cefa&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"

import "./report.vue?vue&type=style&index=0&id=5868cefa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5868cefa"

export default script